import React, { useState, useContext, useEffect } from 'react';

export const InfoContext = React.createContext({
  infoKeys: []
});

export const InfoProvider = ({ children }) => {
  const [infoKeys, setInfoKeys] = useState([]);

  useEffect(() => {
    const projectName = process.env.REACT_APP_PROJECT_NAME;

    const loadInfoKeys = async () => {
      try {
        const infoModule = await import(`./instructions/info-${projectName}.json`);
        setInfoKeys(infoModule.default.infoKeys || []);
      } catch (error) {
        console.warn(`InfoContext: Failed to load info file for project "${projectName}". Using info-default.json`, error);
        setInfoKeys([]);
      }
    };

    loadInfoKeys();
  }, []);

  return <InfoContext.Provider value={{ infoKeys }}>{children}</InfoContext.Provider>;
};

export const useInfo = () => {
  return useContext(InfoContext);
};
